import { MessageCircle } from "lucide-react";
import { useRouterState } from "@tanstack/react-router";
import { useBrand, waLink } from "@/hooks/useSiteContent";
import { productMessage } from "@/lib/productLine";

export function WhatsAppButton() {
  const brand = useBrand();
  const pathname = useRouterState({ select: (r) => r.location.pathname });
  return (
    <a
      href={waLink(brand.whatsapp, productMessage(pathname), "botão flutuante")}
      data-wa-loc="botao-flutuante"
      target="_blank"
      rel="noreferrer"
      aria-label="Falar no WhatsApp"
      // bottom-24 (em vez de bottom-6) + z-[60]: o widget do Huggy se ancora
      // no mesmo canto (bottom/right) com z-index próprio bem alto, então só
      // subir o z-index não garante ficar visível — afastar verticalmente é
      // o que evita a sobreposição de fato.
      className="fixed bottom-24 right-6 z-[60] inline-flex size-14 items-center justify-center rounded-full bg-brand-lime text-brand-yellow-foreground shadow-xl transition-transform hover:scale-110"
    >
      <MessageCircle className="size-7" />
    </a>
  );
}
